import { Languages } from "../Models";

export const LANGUAGES_BY_KEYS: { [key in Languages]: string } = {
    en: "English",
    it: "Italiano",
    ge: "German",
    du: "Nederlands",
    sp: "española",
    fr: "Français",
    po: "Português",
};
